export type PaginationSlot =
  | { type: "page"; page: number }
  | { type: "ellipsis"; key: string };

export function getPaginationSlots(currentPage: number, totalPages: number): PaginationSlot[] {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => ({
      type: "page",
      page: index + 1,
    }));
  }

  if (currentPage <= 4) {
    return [
      { type: "page", page: 1 },
      { type: "page", page: 2 },
      { type: "page", page: 3 },
      { type: "page", page: 4 },
      { type: "ellipsis", key: "right" },
      { type: "page", page: totalPages },
    ];
  }

  if (currentPage >= totalPages - 3) {
    return [
      { type: "page", page: 1 },
      { type: "ellipsis", key: "left" },
      { type: "page", page: totalPages - 3 },
      { type: "page", page: totalPages - 2 },
      { type: "page", page: totalPages - 1 },
      { type: "page", page: totalPages },
    ];
  }

  return [
    { type: "page", page: 1 },
    { type: "ellipsis", key: "left" },
    { type: "page", page: currentPage - 1 },
    { type: "page", page: currentPage },
    { type: "page", page: currentPage + 1 },
    { type: "ellipsis", key: "right" },
    { type: "page", page: totalPages },
  ];
}
